var _defs, _path, _g, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartBluetooth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u7EC4_43238",
    "data-name": "\\u7EC4 43238",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #5ab3f9;\n      }\n\n      .cls-3 {\n        opacity: 0.1;\n      }\n\n      .cls-4 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-5 {\n        fill: #040000;\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_2298",
    "data-name": "\\u77E9\\u5F62 2298",
    className: "cls-1",
    width: 19.982,
    height: 33.813
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35596",
    "data-name": "\\u8DEF\\u5F84 35596",
    className: "cls-2",
    d: "M234.542,44.044a37.5,37.5,0,1,1-37.5-37.5,37.5,37.5,0,0,1,37.5,37.5",
    transform: "translate(-159.542 -6.544)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_43229",
    "data-name": "\\u7EC4 43229",
    className: "cls-3",
    transform: "translate(27.509 21.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_43228",
    "data-name": "\\u7EC4 43228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_43227",
    "data-name": "\\u7EC4 43227",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35597",
    "data-name": "\\u8DEF\\u5F84 35597",
    className: "cls-5",
    d: "M188.973,21.285a10.253,10.253,0,0,1,1.186.74q4.314,3.573,8.6,7.158a1.568,1.568,0,0,1-.02,2.669l-7.3,6.088c-.091.077-.179.155-.295.259l1.965,1.636,5.682,4.734a1.556,1.556,0,0,1,.011,2.606q-4.466,3.733-8.949,7.463a1.542,1.542,0,0,1-1.77.3,1.579,1.579,0,0,1-.893-1.567q.011-5.514,0-11.027v-.414c-.138.129-.225.207-.307.289l-4.644,4.644a1.543,1.543,0,0,1-2.144.214,1.526,1.526,0,0,1-.288-2.1,3.327,3.327,0,0,1,.332-.368q3.069-3.071,6.141-6.138a3.471,3.471,0,0,1,.293-.243c-.121-.13-.2-.22-.284-.3l-6.232-6.234a1.543,1.543,0,0,1-.179-2.165,1.52,1.52,0,0,1,2.1-.23,4.019,4.019,0,0,1,.357.334q2.267,2.261,4.528,4.528a2.6,2.6,0,0,1,.214.289l.105-.052v-.339c0-3.573.02-7.145-.013-10.73a1.835,1.835,0,0,1,1.265-2.044Zm6.579,9.223L190.3,26.136v8.753l5.255-4.38m0,15.362L190.305,41.5v8.753l5.246-4.371",
    transform: "translate(-179.514 -21.285)"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35598",
    "data-name": "\\u8DEF\\u5F84 35598",
    className: "cls-6",
    d: "M188.973,20.718a10.251,10.251,0,0,1,1.186.74q4.314,3.573,8.6,7.158a1.568,1.568,0,0,1-.02,2.669l-7.3,6.088c-.091.077-.179.155-.295.259l1.965,1.636L198.79,44a1.556,1.556,0,0,1,.011,2.606q-4.466,3.733-8.949,7.463a1.542,1.542,0,0,1-1.77.3,1.579,1.579,0,0,1-.893-1.567q.011-5.514,0-11.027v-.414c-.138.129-.225.207-.307.289l-4.644,4.644a1.543,1.543,0,0,1-2.144.214,1.526,1.526,0,0,1-.288-2.1,3.328,3.328,0,0,1,.332-.368q3.069-3.071,6.141-6.138a3.47,3.47,0,0,1,.293-.243c-.121-.13-.2-.22-.284-.3l-6.232-6.234a1.543,1.543,0,0,1-.179-2.165,1.52,1.52,0,0,1,2.1-.23,4.025,4.025,0,0,1,.357.334q2.267,2.261,4.528,4.528a2.606,2.606,0,0,1,.214.289l.105-.052V33.49c0-3.573.02-7.145-.013-10.73a1.835,1.835,0,0,1,1.265-2.044Zm6.579,9.223L190.3,25.562v8.753l5.255-4.38m0,15.362-5.246-4.371V49.68l5.246-4.371",
    transform: "translate(-152.005 -0.124)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartBluetooth);
export default __webpack_public_path__ + "static/media/start_bluetooth.fd7d88aee4b09da0a84d4e7bff254cda.svg";
export { ForwardRef as ReactComponent };